<template>
  <LsModal title="Resume Paused Schedule" track-id="resume_paused_schedule_modal">
    >
    <template #body>
      <p>Reschedule your upcoming mow to an earlier date:</p>
      <LsDatepicker
        v-model="inputs.schedule_at"
        track-id="resume_paused_schedule-schedule_at"
        test-id="schedule_at"
        :validation="{ required: true }"
        name="schedule_at"
        :min-date="minDate"
        :max-date="maxDate"
        class="resume-paused-schedule--schedule_at-datepicker"
        :unselectable-days-of-week="unselectableDays"
        inline
      />
    </template>
    <template #footer
      ><LsButton
        text="resume schedule"
        track-id="resume_paused_schedule-resume_schedule"
        :loading="schedules.loadingStatus.isUpdating"
        @click="resumeSchedule"
    /></template>
  </LsModal>
</template>

<script>
import VueTypes from 'vue-types';
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';
import { LsModal, LsButton, LsDatepicker } from '@/components/common';
import {
  SCHEDULES__RESUME_EARLY,
  REACTIVATION__GET_SELLABLE_DAYS,
  REACTIVATION__UNSELECTABLE_DAYS,
} from '@/store/types';
import { lsDateHelpers } from 'ls-vue-common';

export default {
  name: 'ResumePausedScheduleModal',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    LsModal,
    LsDatepicker,
    LsButton,
  },
  props: {
    //eslint-disable-next-line vue/prop-name-casing
    schedule_id: VueTypes.number.isRequired,
    //eslint-disable-next-line vue/prop-name-casing
    property_id: VueTypes.number.isRequired,
    nextStartDate: VueTypes.string.isRequired,
  },
  data() {
    return {
      inputs: {
        schedule_at: this.minDate,
      },
    };
  },
  computed: {
    ...mapState(['schedules', 'reactivation']),
    ...mapGetters([REACTIVATION__UNSELECTABLE_DAYS]),
    minDate() {
      return lsDateHelpers.getFirstAvailDate({
        sellableDays: this.reactivation.sellableDays,
      });
    },
    maxDate() {
      return moment(this.nextStartDate).toDate();
    },
    unselectableDays() {
      return this[REACTIVATION__UNSELECTABLE_DAYS];
    },
  },
  created() {
    this[REACTIVATION__GET_SELLABLE_DAYS]({ property_id: this.property_id });
  },
  methods: {
    ...mapActions([SCHEDULES__RESUME_EARLY, REACTIVATION__GET_SELLABLE_DAYS]),
    async resumeSchedule() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        return;
      }
      await this[SCHEDULES__RESUME_EARLY]({
        schedule_id: this.schedule_id,
        schedule_at: moment(this.inputs.schedule_at).format('YYYY-MM-DD'),
      });
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.resume-paused-schedule--schedule_at-datepicker {
  padding-top: 20px;
}
</style>
